import { defineProperty as _defineProperty, objectSpread as _objectSpread, extends as _extends, inherits as _inherits, classCallCheck as _classCallCheck, possibleConstructorReturn as _possibleConstructorReturn, getPrototypeOf as _getPrototypeOf, assertThisInitialized as _assertThisInitialized, createClass as _createClass, objectWithoutProperties as _objectWithoutProperties } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withContext, eventBus } from '@piggybank/core';
import { Consumer } from '../Field/context.js';
import pick from 'lodash/fp/pick';
import { TextInput } from '../TextInput/TextInput.js';
import omit from 'lodash/fp/omit';
import isUndefined from 'lodash/fp/isUndefined';
import escapeRegExp from 'lodash/fp/escapeRegExp';
import { unformat, getCursorPos, getFormattedLength, format } from './utils.js';

var CurrencyInputInner = /*#__PURE__*/function (_Component) {
  _inherits(CurrencyInputInner, _Component);

  function CurrencyInputInner() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, CurrencyInputInner);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(CurrencyInputInner)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (_ref) {
      var value = _ref.value,
          event = _ref.event;
      eventBus.dispatch({
        type: 'onChange',
        component: 'CurrencyInput',
        value: unformat(value),
        name: _this.props.name
      });

      _this.props.onChange({
        value: unformat(value),
        event: event
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleCursor", function (e) {
      var el = e.target;
      var selectionStart = el.selectionStart,
          selectionEnd = el.selectionEnd;
      var _this$props = _this.props,
          symbol = _this$props.symbol,
          value = _this$props.value;
      var prefixLength = symbol.length + 1;

      if (!value.length && selectionStart !== selectionEnd || selectionStart === selectionEnd && selectionStart < prefixLength) {
        // Jump cursor in front of the currency symbol prefix
        el.setSelectionRange(prefixLength, prefixLength);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleKeyDown", function (e) {
      var el = e.target,
          keyCode = e.keyCode;
      var selectionStart = el.selectionStart,
          selectionEnd = el.selectionEnd,
          value = el.value;
      var _this$props2 = _this.props,
          symbol = _this$props2.symbol,
          thousandSeparator = _this$props2.thousandSeparator,
          maxLength = _this$props2.maxLength;

      if (selectionStart < value.length) {
        var startInValue = unformat(value.slice(0, selectionStart)).length;
        var posInValue; // Backspace key

        if (keyCode === 8) {
          if (selectionStart === selectionEnd) {
            if (value.charAt(selectionStart - 1) === thousandSeparator) {
              // About to remove a separator behind, skip back one first
              el.setSelectionRange(selectionStart - 1, selectionStart - 1);
            } // Move back before the deleted digit


            posInValue = startInValue - 1;
          } else {
            // Stay put when deleting a selection
            posInValue = startInValue;
          }
        } // Delete key


        if (keyCode === 46) {
          if (value.charAt(selectionStart) === thousandSeparator) {
            // About to remove a separator ahead, skip forward one first
            el.setSelectionRange(selectionStart + 1, selectionStart + 1);
          }

          posInValue = startInValue;
        } // Number keys


        if (keyCode >= 48 && keyCode <= 57 || keyCode >= 96 && keyCode <= 105) {
          if (selectionStart === selectionEnd && _this.props.value.length === maxLength) {
            // Don't move if already at maxLength
            posInValue = startInValue;
          } else {
            // Move forward after the newly entered digit
            posInValue = Math.max(1, Math.min(startInValue + 1, value.length));
          }
        }

        if (!isUndefined(posInValue)) {
          requestAnimationFrame(function () {
            var cursorPos = getCursorPos(el.value, posInValue, symbol.length);
            el.setSelectionRange(cursorPos, cursorPos);
          });
        }
      }
    });

    return _this;
  }

  _createClass(CurrencyInputInner, [{
    key: "render",
    value: function render() {
      var _omit = omit(['onChange'], this.props),
          _omit$value = _omit.value,
          value = _omit$value === void 0 ? '' : _omit$value,
          symbol = _omit.symbol,
          thousandSeparator = _omit.thousandSeparator,
          maxLength = _omit.maxLength,
          forwardedRef = _omit.forwardedRef,
          rest = _objectWithoutProperties(_omit, ["value", "symbol", "thousandSeparator", "maxLength", "forwardedRef"]);

      var formattedMaxLength = getFormattedLength(maxLength, symbol);
      return React.createElement(TextInput, _extends({
        pattern: "[\\d".concat(escapeRegExp("".concat(symbol).concat(thousandSeparator)), " ]*"),
        type: "tel",
        maxLength: formattedMaxLength,
        "aria-label": "currency input",
        ref: forwardedRef,
        onChange: this.handleChange,
        onClick: this.handleCursor,
        onKeyUp: this.handleCursor,
        onKeyDown: this.handleKeyDown,
        value: format(value, this.props)
      }, rest));
    }
  }]);

  return CurrencyInputInner;
}(Component);

_defineProperty(CurrencyInputInner, "defaultProps", {
  thousandSeparator: ','
});

CurrencyInputInner.propTypes = process.env.NODE_ENV !== "production" ? _objectSpread({}, TextInput.propTypes, {
  symbol: PropTypes.string.isRequired,
  thousandSeparator: function thousandSeparator(props, propName, componentName) {
    if (!(typeof props[propName] === 'string' && props[propName].length === 1)) {
      return new Error("Invalid prop ".concat(propName, " supplied to ").concat(componentName, ". Expected a single character."));
    }
  }
}) : {};
var CurrencyInput = React.forwardRef(function (props, ref) {
  return React.createElement(CurrencyInputInner, _extends({}, props, {
    forwardedRef: ref
  }));
});
CurrencyInput.displayName = 'CurrencyInput';
CurrencyInput.propTypes = _objectSpread({}, TextInput.propTypes, {
  symbol: PropTypes.string.isRequired,
  thousandSeparator: PropTypes.string
});
var CurrencyInput$1 = withContext(Consumer, pick(['name', 'value', 'onChange', 'onBlur', 'invalid', 'required', 'describers']))(CurrencyInput);
export default CurrencyInput$1;
export { CurrencyInput };